





import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {ActiveProvide} from "@/support/reactive"

/**
 * Catches analytics events from JDS components.
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsAnalyticsProvider extends Vue {
    @ActiveProvide('jds.analytics') analyticsProvider: Vue|null = null;


    beforeMount () {
        this.analyticsProvider = new Vue();
        this.analyticsProvider.$on('event', (... args) => {
            this.$emit('event', ... args)
        })
    }
}
